import { useController, useFormContext } from 'react-hook-form'
import { Autocomplete, TextField } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { SizingContainer } from 'components/SizingContainer'
import validationsToRules from 'utils/validationsToRules'

import { SearchAutocomplete as SearchAutocompleteProps } from './interface'

export default function SearchAutocomplete({
  name,
  validations,
  label,
  options,
  multiple = false,
  size,
  onChange,
  onFocus,
  defaultValue,
}: SearchAutocompleteProps & DefaultElementProps): JSX.Element {
  const { control, setValue } = useFormContext()
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules: validationsToRules(validations),
  })

  return (
    <SizingContainer className="search-autocomplete-wrap" size={size}>
      <Autocomplete
        {...field}
        onChange={(event, value) => {
          setValue(name, value)
          onChange?.({ value })
        }}
        onFocus={onFocus}
        options={options}
        multiple={multiple}
        disablePortal
        renderInput={(props) => {
          const errorMessageId = `${name}-helper-text`
          return (
            <TextField
              {...props}
              id={name}
              label={label}
              error={error !== undefined}
              helperText={error?.message}
              inputProps={{
                ...props.inputProps,
                'aria-invalid': error !== undefined,
                'aria-describedby': error !== undefined ? errorMessageId : undefined,
              }}
              FormHelperTextProps={{
                id: errorMessageId,
                role: error !== undefined ? 'alert' : undefined,
              }}
            />
          )
        }}
      />
    </SizingContainer>
  )
}
